export const GROUP = '[Group]';

export const GET_GROUPS_SAGA = `${GROUP} GET_GROUPS_SAGA`;
export const SET_GROUPS = `${GROUP} SET_GROUPS`;
export const GET_GROUP_SAGA = `${GROUP} GET_GROUP_SAGA`;
export const SET_GROUP = `${GROUP} SET_GROUP`;
